export default __webpack_public_path__ + "static/media/AyoubBelkas.73168872.png";